import { Component, OnInit } from "@angular/core";

@Component({
  selector: 'app-unauthentication-handler',
  templateUrl: './unauthentication-handler.component.html',
  styleUrls: ['./unauthentication-handler.component.css']
})
export class UnauthenticationHandlerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  returnToHome(){
    window.location.href="/xps/policy";
  }
}
